
import { NavBar } from "@/components/landing/NavBar";
import { WhyChooseUs } from "@/components/landing/WhyChooseUs";
import { FeaturesGrid } from "@/components/landing/FeaturesGrid";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { SmsSection } from "@/components/landing/SmsSection";
import { AutomatedResponses } from "@/components/landing/AutomatedResponses";
import { AppointmentAlerts } from "@/components/landing/AppointmentAlerts";
import { ClosingSection } from "@/components/landing/ClosingSection";
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { Link, useNavigate } from "react-router-dom";
import { Crown } from "lucide-react";
import { InstallPrompt } from "@/components/pwa/InstallPrompt";
import { useEffect } from "react";
import { App } from '@capacitor/app';
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/components/ui/use-toast";

const Index = () => {
  const navigate = useNavigate();
  const { toast } = useToast();

  useEffect(() => {
    const verifyConnections = async () => {
      try {
        // Verify Supabase connection
        const { data, error } = await supabase
          .from('profile_settings')
          .select('count')
          .limit(1);

        if (error) {
          console.error("Supabase connection error:", error);
          toast({
            title: "Database Connection Issue",
            description: "Please check your database configuration",
            variant: "destructive",
          });
        } else {
          console.log("✅ Supabase connection successful");
          toast({
            title: "Connected! 🎉",
            description: "Database connection established successfully",
          });
        }

        // Check platform
        const platformCheck = async () => {
          try {
            const info = await App.getInfo();
            if ('ios' in navigator || /android/i.test(navigator.userAgent)) {
              console.log("Welcome mobile user!");
            }
          } catch (error) {
            console.error("Error checking platform:", error);
          }
        };

        platformCheck();
      } catch (error) {
        console.error("Verification error:", error);
      }
    };

    verifyConnections();
  }, [toast]);

  const handleCharlieClick = (e: React.MouseEvent<HTMLDivElement>) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const width = rect.width;
    
    if (x > width * 0.66) {
      navigate('/story');
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <NavBar />
      <main className="relative">
        <div className="relative z-10 space-y-12 py-8">
          <WhyChooseUs />
          <FeaturesGrid />
          <HowItWorks />
          <SmsSection />
          <AutomatedResponses />
          <AppointmentAlerts />
          <ClosingSection />
        </div>
      </main>

      <InstallPrompt />

      <div className="fixed bottom-4 right-4 z-50">
        <Link to="/signup">
          <Button
            className="w-20 h-20 rounded-full bg-gradient-to-r from-hotbot-gold via-hotbot-pink to-hotbot-purple
                     hover:from-hotbot-pink hover:via-hotbot-purple hover:to-hotbot-gold
                     shadow-lg hover:shadow-xl transition-all duration-500 
                     flex flex-col items-center justify-center border-2 border-white gap-1"
          >
            <Crown className="w-8 h-8 text-white" />
            <span className="text-white text-sm font-bold">Sign Up</span>
          </Button>
        </Link>
      </div>

      <div 
        onClick={handleCharlieClick}
        className="w-full py-2 bg-gradient-to-r from-pink-300 via-purple-300 to-teal-300 cursor-pointer transition-all duration-500"
      >
        <p className="text-center text-xs font-dancing text-white">
          Charlie Love
        </p>
      </div>
    </div>
  );
};

export default Index;
